import { observable, computed, extendObservable, action } from 'mobx';

export default class SaleEditStore {
  @observable page = 1;
  @observable offerData = {};
  @observable docs = [];

  @computed get isPage1Valid() {
    const data = this.offerData;
    return (
      !!data.object_type &&
      !!data.surface_area &&
      !!data.object_address &&
      !!data.deed1 &&
      !!data.ownership &&
      (data.ownership !== 'share' ||
        (!!data.ownership_share && !!data.ownership_total))
    );
  }

  @computed get isPage2Valid() {
    const data = this.offerData;
    const mortgage = data.mortgage;
    return (
      !!data.handover && (!mortgage || (!!mortgage && data.mortgage_detail))
    );
  }

  @computed get isPage3Valid() {
    return true;
  }

  @action initialize(offerData, docs) {
    this.offerData = Object.assign({}, offerData);
    this.docs = (docs || []).slice();
    extendObservable(this.offerData, {
      object_type: offerData.object_type || '',
      surface_area: offerData.surface_area || 0,
      objectno: offerData.objectno || '',
      object_address: offerData.object_address || '',
      deed1: offerData.deed1 || '',
      ownership: offerData.ownership || '',
      ownership_share: offerData.ownership_share || '',
      ownership_total: offerData.ownership_total || '',
      ubernommene_lasten: offerData.ubernommene_lasten || null,
      sonstige_gegenleistungen: offerData.sonstige_gegenleistungen || null,
      additional_sellers: offerData.additional_sellers || [],
      vat_percentage: offerData.vat_percentage,
      vat_mandate: offerData.vat_mandate || false,
      mortgage: offerData.mortgage || null,
      mortgage_detail: offerData.mortgage_detail || null,
      mortgage_condition: offerData.mortgage_condition || null,
      deferred_sale: offerData.deferred_sale || false,
      handover: offerData.handover || null,
    });
  }
}

export { SaleEditStore };



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_lu/stores/index.js